const isInterventionRegistrationRedirect = (landingsPage) => {
   const interventionLandingPages =  ["esteemup", "i-SleepBioClock", "moodpep", "rel@x", "getstarted", "lifehack", "getagrip", "oplossingshop", "goodenough", "socialife"]
   return interventionLandingPages.includes(landingsPage)
}

export default isInterventionRegistrationRedirect
